import DrawResultScreen from "./DrawResultScreen";

export default DrawResultScreen;